import React from 'react';
import { FormControl, Typography, TextField } from '@mui/material';

import RequiredMarker from '../requiredMarker';
import RenderIf from '../../../../../../renderIf';

const ReturnReason = ({ selectedStatus, returnReason, setReturnReason }) => {
    const [hasInteracted, setHasInteracted] = React.useState(false);

    React.useEffect(
        () => () => {
            //unmount
            setHasInteracted(false);
            setReturnReason('');
        },
        []
    );

    return (
        <FormControl
            fullWidth
            size="small"
        >
            <Typography
                sx={{
                    marginTop: (theme) => theme.spacing(2),
                }}
            >
                <RenderIf isTrue={selectedStatus === 3 || selectedStatus === 7}>
                    <RequiredMarker />
                    &nbsp;
                </RenderIf>
                Change reason:
            </Typography>
            <TextField
                value={returnReason}
                onBlur={() => setHasInteracted(true)}
                onChange={(event) => setReturnReason(event.target.value)}
                error={(selectedStatus === 3 || selectedStatus === 7) && hasInteracted && returnReason === ''}
                multiline
                maxRows={4}
                minRows={4}
            />
        </FormControl>
    );
};

export default ReturnReason;
